<div class="contenitore">
  <div class="btn">
    <button class="btn-close" mat-dialog-close>
      <mat-icon svgIcon="mat:close"></mat-icon>
    </button>
  </div>
  <h1><img src="../../../assets/img/demo/thunderbolt_white.svg">{{item.type}}</h1>
  <div class="body-1" [innerHtml]="item.description"></div>
</div>
